import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { VehicleconfigService } from '../vehicleconfig.service';
import { VehicleConfigModel } from 'src/app/ceq/common/models/Vehicleconfig.Model';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-vehicleconfig-detail',
  templateUrl: './vehicleconfig-detail.component.html',
  styleUrls: ['./vehicleconfig-detail.component.scss']
})
export class VehicleconfigDetailComponent implements OnInit {

  userLogin: UserLogin;
  vehicleconfig: VehicleConfigModel = new VehicleConfigModel();
  isNew: boolean = false;

  constructor(
    private url: ActivatedRoute,
    private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private vehicleConfigService: VehicleconfigService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    const currentKey = this.url.snapshot.paramMap.get('id');
    
    this.vehicleconfig.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentKey) || currentKey === 'create') {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.vehicleconfig.VehicleKey = currentKey!;
      this.getVehicleConfig();
    }
  }

  getVehicleConfig() {
    this.vehicleConfigService.getVehicleConfigByKey(this.vehicleconfig.VehicleKey).subscribe({
      next: (data) => {
        if (data) this.vehicleconfig = data;
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró el vehículo solicitado", 'error', '¡Error!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.vehicleConfigService.addVehicleConfig(this.vehicleconfig)
      : this.vehicleConfigService.updateVehicleConfig(this.vehicleconfig);

    operation.subscribe({
      next: async () => {
        const msg = this.isNew ? 'Configuración vehicular creada' : 'Configuración vehicular actualizada';
        await this.globalFunctionService.messageBimbo(msg, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        const errorMsg = err.error || 'Ocurrió un error al procesar la solicitud';
        await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    this.router.navigate(['/tax/vehicleconfig']);
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}